<app-modal title="UPDATE_CONFLICT.MODAL_TITLE" [hideButtons]="true" [hideCloseIcon]="true">
  <div class="row mb-4">
    <div class="col-6">
      <app-mdb-button [text]="'UPDATE_CONFLICT.SAVE_YOURS'"
        (onClick)="ref.close()"
      [styles]="{'text-transform': 'none'}"></app-mdb-button>
    </div>
    <div class="col-6">
      <app-mdb-button color="secondary"
        [text]="'UPDATE_CONFLICT.SAVE_SERVER_DATA'"
        (onClick)="window.location.reload()"
      [styles]="{'text-transform': 'none'}"></app-mdb-button>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-6"><h5 class="mb-0">{{'UPDATE_CONFLICT.YOUR_DATA'|translate}}</h5></div>
    <div class="col-6"><h5 class="mb-0">{{'UPDATE_CONFLICT.SERVER_DATA'|translate}}</h5></div>
  </div>

  <hr class="my-2">

  <ng-container *ngTemplateOutlet="recursiveTemplate; context: { $implicit: rootConflict.conflictChildren, lastIndex: rootConflict.conflictChildren!.length-1 }"></ng-container>

  <div class="d-flex justify-content-end">
    @if (!selectChanges) {
      <app-mdb-button
        [styles]="{'text-transform': 'none'}"
        [outlined]="true"
        [text]="'UPDATE_CONFLICT.SELECT_VALUES_TO_SAVE'"
      (onClick)="selectChanges = true"></app-mdb-button>
    }
    @if (selectChanges) {
      <app-mdb-button
        [styles]="{'text-transform': 'none'}"
        (onClick)="ref.close(selectedValues)"
      [text]="'UPDATE_CONFLICT.SAVE_SELECTED_VALUES'"></app-mdb-button>
    }
  </div>

  <!-- Recursive Template -->
  <!-- TODO: Handle Arrays -->
  <ng-template #recursiveTemplate let-conflictChildren let-currentIndex let-lastIndex>
    @for (conflictChild of conflictChildren; track conflictChild; let i = $index) {
      <span>
        @if (!conflictChild.conflictChildren || conflictChild.conflictChildren?.length == 0) {
          <div>
            <ng-container *ngTemplateOutlet="conflictProperty; context: { $implicit: conflictChild }"></ng-container>
          </div>
        }
        @if (conflictChild.conflictChildren?.length) {
          <span>
            <ng-container *ngTemplateOutlet="recursiveTemplate; context: { $implicit: conflictChild.conflictChildren, currentIndex: i, lastIndex: conflictChild.conflictChildren.length-1 }"></ng-container>
          </span>
        }
      </span>
    }
  </ng-template>

  <ng-template #conflictProperty let-conflict>
    <div>
      <p class="mb-0 fw-bold">{{conflict.translation}}</p>
      <div class="row">
        <div class="col-6">
          <p class="mb-0 d-sm-none">{{'UPDATE_CONFLICT.YOUR_VALUE'|translate}}</p>
          @if (selectChanges) {
            <input
              mdbRadio
              class="form-check-input"
              type="radio"
              [checked]="true"
              [value]="conflict.clientValue"
              [(ngModel)]="selectedValues[conflict.fullName]"
              name="{{conflict.fullName}}"
              id="{{conflict.fullName}}" />
          }
          <label for="{{conflict.fullName}}">{{valueToString(conflict.clientValue)}}</label>
        </div>
        <div class="col-6">
          <p class="mb-0 d-sm-none">{{'UPDATE_CONFLICT.SERVER_VALUE'|translate}}</p>
          @if (selectChanges) {
            <input
              mdbRadio
              class="form-check-input"
              type="radio"
              [value]="conflict.serverValue"
              [(ngModel)]="selectedValues[conflict.fullName]"
              name="{{conflict.fullName}}"
              id="{{conflict.fullName + '_server'}}" />
          }
          <label for="{{conflict.fullName + '_server'}}">{{valueToString(conflict.serverValue)}}</label>
        </div>
      </div>
      <hr class="my-2">
    </div>
  </ng-template>
</app-modal>
